// DCL-507: warn a practice on a complimentary (Stripe-less, $0) Premium trial
// once per session during the trial's final 7 days. The trial otherwise ends
// silently — nothing renews it and nothing bills it — so this toast is the only
// in-app notice before Premium features disappear. Deliberately bounded to the
// trial itself: once premium_access flips false the condition can never match
// again, so there is no post-expiry nagging (post-expiry messaging lives on the
// subscription page, DCL-508). Extending a trial from the console pushes
// active_until out, which automatically retreats the banner until the new date
// is 7 days away. Same once-per-session idiom as EmailSuppressionWarning.
angular.module('dentalLinks')
.factory('TrialExpiryWarning', ['Subscription', 'Notification', 'Auth', '$location', '$filter', '$sce',
    function (Subscription, Notification, Auth, $location, $filter, $sce) {
        var checkedThisSession = false;

        var WARNING_WINDOW_DAYS = 7;
        var DAY_MS = 24 * 60 * 60 * 1000;

        // The toast body is $compile'd against NotificationAreaController's scope
        // (index.html's `dynamic-html`), and AngularJS 1.8 has no expression
        // sandbox — so the message stays a static string and the server-derived
        // trial end date is handed over in params and bound with ng-bind
        // (DCL-462 posture; see emailSuppressionWarning.js for the full argument).
        // trustAsHtml is what lets dynamic-html compile them (DCL-702).
        //
        // Copy goals (DCL-507): honest end date, upgrade prompt, reassurance that
        // incoming referrals are never blocked on Basic, positive framing of the
        // rest of Premium.
        var SPECIALIST_MESSAGE = $sce.trustAsHtml(
            'Your complimentary Premium trial ends on ' +
            '<strong ng-bind="notification.params.trialEndsOn"></strong>. ' +
            'After that you\'ll be on the free Basic plan &mdash; every referral sent to you ' +
            'will still arrive in full; Basic includes 5 incoming referrals per month, ' +
            'which covers most practices. To keep unlimited incoming referrals, multiple ' +
            'locations and providers, custom branding, and the patient portal, ' +
            '<a href="" ng-click="notificationAction()">upgrade to Premium</a>.');

        // General dentistry has no incoming quota on any tier (DCL-538), so the
        // 5-per-month reassurance would be false for it.
        var GENERAL_DENTISTRY_MESSAGE = $sce.trustAsHtml(
            'Your complimentary Premium trial ends on ' +
            '<strong ng-bind="notification.params.trialEndsOn"></strong>. ' +
            'After that you\'ll be on the free Basic plan &mdash; referral sending stays free ' +
            'and unlimited. To keep multiple locations and providers, custom website ' +
            'integration, custom branding, and the patient portal, ' +
            '<a href="" ng-click="notificationAction()">upgrade to Premium</a>.');

        function withinWarningWindow(activeUntil) {
            var endsAt = new Date(activeUntil).getTime();
            if (isNaN(endsAt)) {
                return false;
            }
            return endsAt - Date.now() <= WARNING_WINDOW_DAYS * DAY_MS;
        }

        function checkAndNotify() {
            var auth = Auth.get();
            if (!auth || !auth.id) {
                return;
            }
            if (checkedThisSession) {
                return;
            }
            checkedThisSession = true;

            Subscription.getStatus({}, function (status) {
                var subscription = status.subscription;
                if (!status.premium_access || !subscription || !subscription.complimentary) {
                    return;
                }
                if (!withinWarningWindow(subscription.active_until)) {
                    return;
                }

                var message = status.practice_type === 'general_dentistry' ?
                    GENERAL_DENTISTRY_MESSAGE : SPECIALIST_MESSAGE;

                Notification.warning(message, {
                    dontHideOnRequest: true,
                    trialEndsOn: $filter('date')(new Date(subscription.active_until), 'MMMM d, yyyy'),
                    // Following the link is the user acting on the warning (same
                    // reasoning as DCL-483): dismiss the dontHideOnRequest toast on
                    // the way to the upgrade flow, which DCL-508 made work during
                    // an active complimentary trial.
                    action: function () {
                        Notification.dismiss();
                        $location.path('/admin/practice').search({upgrade: true, src: 'trial_toast'});
                    }
                });
            }, angular.noop); // a failed check must never break the page
        }

        // Logout and impersonation start/stop are $state reloads, not page
        // reloads, so this service instance outlives the identity that armed the
        // flag — callers that switch identity must reset (DCL-462 idiom).
        function reset() {
            checkedThisSession = false;
        }

        return {
            checkAndNotify: checkAndNotify,
            reset: reset
        };
    }]);
